import { useState, useEffect } from 'react';

type Language = 'es' | 'en';

interface Translations {
  [key: string]: any;
}

const translations: Record<Language, Translations> = {
  es: {},
  en: {}
};

// Load translations dynamically
const loadTranslations = async () => {
  try {
    const esCommon = await import('../i18n/local/es/common');
    const enCommon = await import('../i18n/local/en/common');
    
    translations.es = { ...esCommon.common };
    translations.en = { ...enCommon.common };
  } catch (error) {
    console.error('Error loading translations:', error);
  }
};

// Initialize translations
loadTranslations();

export const useTranslation = () => {
  const [language, setLanguage] = useState<Language>('es');
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') as Language;
    if (savedLanguage && (savedLanguage === 'es' || savedLanguage === 'en')) {
      setLanguage(savedLanguage);
    }
    setIsLoaded(true);

    const handleLanguageChange = (event: CustomEvent) => {
      setLanguage(event.detail as Language);
    };

    window.addEventListener('languageChange', handleLanguageChange as EventListener);

    return () => {
      window.removeEventListener('languageChange', handleLanguageChange as EventListener);
    };
  }, []);

  const t = (key: string): string => {
    if (!isLoaded) return key;
    
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return typeof value === 'string' ? value : key;
  };

  return { t, language, isLoaded };
};